import { Divider, DividerProps } from '@mui/material'
import React, { FC } from 'react'

const DividerWrapper: FC<DividerProps> = ({ ...props }) => <Divider {...props} />

export default DividerWrapper
